import { debugLog } from './debug';

/**
 * Captures current settings for a view type (to save as defaults)
 * Uses ref to get current values to avoid stale closure issues
 * 
 * @param {string} type - View type (flow, kanban, table, gantt, todolist)
 * @param {Object} currentValues - Current values from ref
 * @returns {Object} Settings object for the view type
 */
export function captureSettingsForType(type, currentValues) {
  const vals = currentValues;
  
  const settings = {
    filters: vals.filtersPerView?.[type] || {},
    sortSetting: vals.localSprint?.sortSettingsPerView?.[type] || 'manual',
    cardDisplaySettings: vals.localSprint?.cardDisplaySettings?.[type],
    showArchived: vals.showArchived,
    showActionableOnly: vals.showActionableOnly,
    showNestedCampaigns: vals.showNestedCampaigns,
  };

  // Type-specific settings
  switch (type) {
    case 'flow':
      settings.flowViewVisibility = vals.flowViewVisibility;
      settings.viewport = vals.flowViewport || { pan: { x: 0, y: 0 }, zoom: 1 };
      // Flow FOKUS mode - stored in toolbar state
      settings.fokusMode = vals.flowFokus ? {
        isActive: vals.flowFokus.isFokusMode,
        focusedTaskIds: vals.flowFokus.focusedTaskIds ? Array.from(vals.flowFokus.focusedTaskIds) : [],
      } : { isActive: false, focusedTaskIds: [] };
      break;
    case 'kanban':
      settings.swimlaneSetting = vals.localSprint?.swimlaneSetting || 'none';
      settings.fokusMode = vals.kanbanFokus ? {
        isActive: vals.kanbanFokus.isFokusMode,
        focusedTaskIds: vals.kanbanFokus.primaryFokusedIds ? Array.from(vals.kanbanFokus.primaryFokusedIds) : [],
      } : { isActive: false, focusedTaskIds: [] };
      break;
    case 'table':
      settings.columnVisibility = vals.tableColumnVisibility;
      settings.fokusMode = vals.tableFokus ? {
        isActive: vals.tableFokus.isFokusMode,
        focusedTaskIds: vals.tableFokus.primaryFokusedIds ? Array.from(vals.tableFokus.primaryFokusedIds) : [],
      } : { isActive: false, focusedTaskIds: [] };
      break;
    case 'gantt':
      settings.ganttSwimlane = vals.ganttSwimlane || 'none';
      settings.viewport = vals.ganttViewport || { zoomLevel: 'week', scrollPosition: null };
      settings.fokusMode = vals.ganttFokus ? {
        isActive: vals.ganttFokus.isFokusMode,
        focusedTaskIds: vals.ganttFokus.primaryFokusedIds ? Array.from(vals.ganttFokus.primaryFokusedIds) : [],
      } : { isActive: false, focusedTaskIds: [] };
      break;
    case 'todolist':
      settings.elementVisibility = vals.todoElementVisibility;
      settings.viewMode = vals.todoViewMode || 'master';
      settings.swimlaneGroupBy = vals.todoSwimlaneGroupBy || 'status';
      // New: Swimlane setting (same as Kanban)
      settings.todoSwimlane = vals.todoSwimlane || 'none';
      // New: Show nested items toggle
      settings.todoShowNestedItems = vals.todoShowNestedItems !== false; // Default true
      settings.fokusMode = vals.todoFokus ? {
        isActive: vals.todoFokus.isFokusMode,
        focusedTaskIds: vals.todoFokus.primaryFokusedIds ? Array.from(vals.todoFokus.primaryFokusedIds) : [],
      } : { isActive: false, focusedTaskIds: [] };
      break;
    case 'neural':
      settings.fokusMode = vals.neuralFokus ? {
        isActive: vals.neuralFokus.isFokusMode,
        focusedTaskIds: vals.neuralFokus.primaryFokusedIds ? Array.from(vals.neuralFokus.primaryFokusedIds) : [],
      } : { isActive: false, focusedTaskIds: [] };
      break;
    default:
      break;
  }

  debugLog('captureCurrentSettings', type, {
    ...settings,
    cardDisplaySettings: settings.cardDisplaySettings,
    fokusMode: settings.fokusMode,
  });
  return settings;
}
